"use strict";

require("core-js/modules/es6.string.bold");

require("core-js/modules/es6.string.small");

exports.__esModule = true;
exports.Text = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  line-height:  ", ";\n  flex-direction: row;\n  ", "\n  font-size: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  color: ", ";\n  ", "\n  @media (max-width: 767px) {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var Text = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.padding ? "padding:" + props.padding + ";" : "";
}, function (props) {
  return props.height ? "height:" + props.height + ";" : "";
}, function (props) {
  return props.maxWidth ? "max-width:" + props.maxWidth + ";" : "";
}, function (props) {
  return props.fontStyle ? "font-style:" + props.fontStyle + ";" : "";
}, function (props) {
  return props.letterSpacing ? "letter-spacing:" + props.letterSpacing + ";" : "";
}, function (props) {
  return props.lineHeight ? props.lineHeight : "1.6";
}, function (props) {
  return props.margin ? "margin:" + props.margin + ";" : "";
}, function (props) {
  return props.xlarge ? "1.6rem" : props.large ? "1.1rem" : props.small ? ".75rem" : props.size || "1.2rem";
}, function (props) {
  return props.justifyContent ? "justify-content: " + props.justifyContent + ";" : "";
}, function (props) {
  return props.alignItems ? "align-items: " + props.alignItems + ";" : "";
}, function (props) {
  return props.bold ? "font-weight: bold;" : "";
}, function (props) {
  return props.fontWeight ? "font-weight: " + props.fontWeight + ";" : "";
}, function (props) {
  return props.rightAlign ? "text-align: right;" : props.center ? "text-align: center;" : props.justify ? "text-align: justify;" : "";
}, function (props) {
  return props.color ? "" + props.color : "#000";
}, function (props) {
  return props.textTransform ? "text-transform: " + props.textTransform + ";" : "";
}, function (_ref) {
  var mobileViewSize = _ref.mobileViewSize;
  return mobileViewSize ? "font-size: " + (mobileViewSize === "xlarge" ? "1.6rem" : mobileViewSize === "large" ? "1.1rem" : mobileViewSize === "small" ? ".75rem" : mobileViewSize === "default" ? ".9rem" : mobileViewSize) + ";" : "font-size: 1.4rem";
});

exports.Text = Text;